<ya-map
  style="z-index: 0"
  [state]="stateMap"
  [options]="optionsMap"
  (ready)="onMapReady($event)"
  (sizechange)="closeBalloon($event)"
>
  <ya-clusterer [options]="clustererOptions">
    <ya-placemark
      *ngFor="let placemark of placemarks$ | async"
      [geometry]="placemark.point"
      [options]="placemark.options"
      [properties]="placemark.properties"
      (yaclick)="selectPlacemark(placemark)"
    ></ya-placemark>
  </ya-clusterer>
</ya-map>

<app-shared-balloon-mobile
  *ngIf="isOpenBalloonMobile && selectedLabomat"
  (closeBalloon)="closeBalloonMobile()"
>
  <div class="typography typography-headline">Лабомат</div>
  <div class="grey-800 mt-8">{{ selectedLabomat.labomatInfo.address }}</div>
</app-shared-balloon-mobile>
